export { default } from './CardContent';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/CardContent/index.js
// module id = 579
// module chunks = 121